import React from "react";

import Form from "antd/es/form";
import cn from "classnames";

import { EntityType } from "@mapmycustomers/shared/enum";

import Checkbox from "@app/component/input/Checkbox";
import TextWithInfo from "@app/component/typography/TextWithInfo";
import SandboxOption from "@app/scene/settings/component/Sandbox/type/SandboxOption";

import styles from "../SandboxItems.module.scss";

interface Props {
  option: SandboxOption;
}

const OptionCheckBox: React.FC<Props> = ({
  option: {
    checkValue,
    dependencies,
    disabled,
    entityTypes,
    getEntityName,
    name,
    nameHint,
    namePath,
    unCheckValue,
  },
}) => {
  return (
    <Form.Item shouldUpdate>
      {({ getFieldValue, setFieldsValue }) => {
        const value = getFieldValue(namePath);
        const isOptionsGroup = !!getEntityName && entityTypes;
        const checked = isOptionsGroup
          ? entityTypes.every((type) => ((value as EntityType[]) ?? []).includes(type))
          : (value as boolean);
        const indeterminate = getEntityName
          ? !checked && ((value as EntityType[]) ?? []).length > 0
          : false;
        const isDisabled =
          disabled ??
          (dependencies ? dependencies.some((dependency) => getFieldValue(dependency)) : false);
        const handleChange = (value: boolean) => setFieldsValue(value ? checkValue : unCheckValue);

        const handleEntityChange = (checked: boolean, entityType: EntityType) =>
          setFieldsValue({
            [namePath]: checked
              ? [...((value as EntityType[]) ?? []), entityType]
              : ((value as EntityType[]) ?? []).filter((type) => type !== entityType),
          });

        return (
          <div>
            <Checkbox
              checked={checked}
              disabled={isDisabled}
              indeterminate={indeterminate}
              onChange={handleChange}
            >
              <TextWithInfo info={nameHint}>{name}</TextWithInfo>
            </Checkbox>
            {isOptionsGroup &&
              entityTypes.map((entityType) => (
                <div
                  className={cn([styles.formItem, styles.subItem])}
                  key={`sandbox-config-item-${namePath}-${entityType}`}
                >
                  <Checkbox
                    checked={((value as EntityType[]) ?? []).includes(entityType)}
                    disabled={isDisabled}
                    onChange={(value) => handleEntityChange(value, entityType)}
                  >
                    {getEntityName(entityType)}
                  </Checkbox>
                </div>
              ))}
          </div>
        );
      }}
    </Form.Item>
  );
};

export default OptionCheckBox;
